import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation Update($data: UpdateAdmissionWayInput!) {
    updateAdmissionWay(data: $data) {
      id
    }
  }
`);

export const responseUpdateKey = "updateAdmissionWay";
export interface UpdateGql {
  updateAdmissionWay: {
    id: number;
  };
}
